export const TIMER_REPEAT_PROPOSAL = 'timer_repeat_proposal'
export const TIMER_REPEAT_PROPOSAL_TIME = 60000
